export default "__VITE_ASSET__giMF0D18__"